import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { GetPropertyTypesInputDto, PropertyTypeCreateDto, PropertyTypeDto, PropertyTypeExcelDownloadDto, PropertyTypeUpdateDto } from '../dtos/property-type/models';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';

@Injectable({
  providedIn: 'root',
})
export class PropertyTypeService {
  private restService = inject(RestService);
  apiName = 'Planning';
  

  create = (input: PropertyTypeCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PropertyTypeDto>({
      method: 'POST',
      url: '/api/planning/propertyTypes',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/planning/propertyTypes/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/planning/propertyTypes',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PropertyTypeDto>({
      method: 'GET',
      url: `/api/planning/propertyTypes/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/planning/propertyTypes/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetPropertyTypesInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<PropertyTypeDto>>({
      method: 'GET',
      url: '/api/planning/propertyTypes',
      params: { name: input.name, code: input.code, remsoftName: input.remsoftName, isSapFicoApplied: input.isSapFicoApplied, propertyTypeGroupId: input.propertyTypeGroupId, propertyTypeGroupName: input.propertyTypeGroupName, nextPropertyTypeId: input.nextPropertyTypeId, propertyTypeName: input.propertyTypeName, isFOManagement: input.isFOManagement, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: PropertyTypeExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/planning/propertyTypes/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, name: input.name, code: input.code, remsoftName: input.remsoftName, isSapFicoApplied: input.isSapFicoApplied, propertyTypeGroupId: input.propertyTypeGroupId, propertyTypeGroupName: input.propertyTypeGroupName, nextPropertyTypeId: input.nextPropertyTypeId, propertyTypeName: input.propertyTypeName, isFOManagement: input.isFOManagement, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PropertyTypeDto[]>({
      method: 'GET',
      url: '/api/planning/propertyTypes/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: PropertyTypeUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PropertyTypeDto>({
      method: 'PUT',
      url: `/api/planning/propertyTypes/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}